<template>
    <div>
        <div v-if="$root.loading" class="loading">در حال بارگذاری...</div>

        <div class="border" style="background: #f5f5f5;max-width: 600px;margin: auto;">
            <template v-if="show">
                <div class="modal-header">
                    <h5 class="modal-title" id="guestCommentModalTitle">
                        <i class="fa fa-commenting-o"></i>
                        شما هم دیدگاهتان را ارسال کنید
                    </h5>
                </div>
                <div class="modal-body">

                    <div class="form-group form-row">
                        <div class="col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-tm-12 col-12">
                            <label for="name">نام و نام خانوادگی<span class="text-danger">*</span></label>
                        </div>
                        <div class="col-xx-8 col-el-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-tm-12 col-12">
                            <input type="text" id="name" v-model="item.name" class="form-control" :disabled="!!name">
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <div class="col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-tm-12 col-12">
                            <label for="email">ایمیل <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-xx-8 col-el-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-tm-12 col-12">
                            <input type="text" id="email" v-model="item.email" class="form-control en"
                                   :disabled="!!email">
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <div class="col-xx-4 col-el-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-tm-12 col-12">
                            <label for="score" class="num-fa">از 1 تا 5 امتیاز دهید <span
                                class="text-danger">*</span></label>
                        </div>
                        <div class="col-xx-8 col-el-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-tm-12 col-12">
                            <select class="form-control num-fa" id="score" v-model="item.score">
                                <option value="5">5 - عالی</option>
                                <option value="4">4 - خوب</option>
                                <option value="3">3 - متوسط</option>
                                <option value="2">2 - بد</option>
                                <option value="1">1 - افتضاح</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <div class="col-xx-12 col-el-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-tm-12 col-12">
                            <textarea id="text" v-model="item.text" class="form-control"
                                      placeholder="دیدگاهتان را اینجا بنویسید."></textarea>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary pl-5 pr-5" :disabled="$root.loading"
                            @click.prevent="save">
                        ارسال
                    </button>
                    <!--
                    <button type="button" class="btn btn-danger pl-5 pr-5" data-dismiss="modal">انصراف</button>
                    -->
                </div>
            </template>
            <template v-else>
                <div class="alert alert-success" style="margin: 20px;">{{ message }}</div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "site-guest-comment-form",
    data() {
        let self = this;

        return {
            show: true,
            message: '',
            item: {
                object_id: '',
                name: '',
                email: '',
                text: '',
                type: '',
                score: '',
            }
        };
    },
    props: {
        // article, product
        type: {
            type: String,
            require: true,
        },
        objectId: {
            type: String,
            require: true,
        },
        name: {
            type: String,
            default() {
                return '';
            }
        },
        email: {
            type: String,
            default() {
                return '';
            }
        },
    },
    methods: {
        save() {
            let self = this;

            self.$root.loading = true;
            axios.post('comments', self.item)
                .then((response) => {
                    self.$root.loading = false;
                    $('#guestCommentModal').modal('hide');
                    self.$root.toastr.success(response.data.message);
                    self.message = response.data.message;
                    self.show = false;
                })
                .catch((error) => {
                    self.$root.onError(error);
                });
        }
    },
    created() {
        this.item.object_id = this.objectId;
        this.item.name = this.name;
        this.item.email = this.email;
        this.item.type = this.type;

        //window.C = this;
    }
}
</script>

<style scoped>

</style>
